import React, { useEffect, useMemo, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TERMS_PATH = '/legal/os-tos.txt';

const isSubheading = (line) => /^\d+(?:\.\d+)+\s+\S/.test(line);
const isTopLevelHeading = (line) => /^\d+\.\s+\S/.test(line);
const isHeading = (line) => isTopLevelHeading(line) || isSubheading(line);

const headingClassName = 'text-2xl font-bold text-gray-900';

const TermsOfService2026 = () => {
  const [termsText, setTermsText] = useState('');

  useEffect(() => {
    let isMounted = true;

    fetch(TERMS_PATH)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Unable to load terms from ${TERMS_PATH}`);
        }
        return response.text();
      })
      .then((text) => {
        if (isMounted) {
          setTermsText(text);
        }
      })
      .catch(() => {
        if (isMounted) {
          setTermsText('');
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  const termsLines = useMemo(() => {
    return termsText
      .split('\n')
      .map((line) => line.trim())
      .filter(Boolean)
      .filter((line) => line.toLowerCase() !== 'terms of service')
      .filter((line) => line !== 'Asha AI-Native PMS')
      .filter((line) => line !== 'Asha Dental AI Operating System')
      .filter((line) => !line.startsWith('Last Updated:'))
      .filter((line) => !line.startsWith('Redline'));
  }, [termsText]);

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Header />

      <section className="pt-32 pb-16 px-6">
        <div className="container mx-auto max-w-4xl">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Terms of Service
          </h1>
          <p className="text-lg text-gray-600">
            Last Updated: July 20, 2026
          </p>
        </div>
      </section>

      <section className="pb-20 px-6">
        <div className="container mx-auto max-w-4xl">
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-sm">
            <div className="prose prose-lg max-w-none">
              {termsLines.length > 0 ? (
                termsLines.map((line, index) => {
                  if (isHeading(line)) {
                    if (isTopLevelHeading(line)) {
                      return (
                        <h3 key={`${line}-${index}`} className={`${headingClassName} mt-12 mb-4 first:mt-0`}>
                          {line}
                        </h3>
                      );
                    }

                    return (
                      <h4 key={`${line}-${index}`} className={`${headingClassName} mt-8 mb-2`}>
                        {line}
                      </h4>
                    );
                  }

                  return (
                    <p key={`${line}-${index}`} className="text-gray-700 leading-relaxed mb-4">
                      {line}
                    </p>
                  );
                })
              ) : (
                <p className="text-gray-700 leading-relaxed">
                  Loading terms...
                </p>
              )}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermsOfService2026;
